// 设备图标
import wxqxy from "static/knowledge/wxqxy.png";
import zwyyjcy from "static/knowledge/zwyyjcy.png";
import gpjcy from "static/knowledge/gpjcy.png";
import trjcy from "static/knowledge/trjcy.png";
// 设备数据字段对应的中文名称
export const zhibiao = {
  airHumidity: "环境湿度",
  airTemperature: "环境温度",
  airPressure: "大气压",
  lux: "光照",
  humidity: "土壤水分",
  ec: "EC",
  temperature: "土壤温度",
  sugar: "糖度",
  moisture: "干物质",
  acidity: "酸度",
  fiber: "纤维素",
  fat: "脂肪",
  protein: "蛋白质",
  spad: "SPAD",
  nitrogenContent: "叶片氮含量",
  airTemp: "环境温度",
  lightInt: "光照强度",
  soilPh: "土壤PH值",
  soilFertility: "土壤EC",
  soilTemp: "土壤温度",
  soilHumidity: "土壤水分"
};
// 设备数据字段对应的图标类名
export const icon = {
  airHumidity: "icon-monitor-evwet",
  airTemperature: "icon-monitor-evtemp",
  airPressure: "icon-monitor-pres",
  lux: "icon-monitor-light",
  humidity: "icon-monitor-wet",
  ec: "icon-monitor-fertility",
  temperature: "icon-monitor-temp",
  sugar: "icon-spectrum-suger",
  moisture: "icon-spectrum-water",
  acidity: "icon-spectrum-ph",
  fiber: "icon-spectrum-growth",
  fat: "icon-spectrum-zf",
  protein: "icon-spectrum-dbz",
  spad: "icon-monitor-yls",
  nitrogenContent: "icon-monitor-n",
  airTemp: "icon-monitor-evtemp",
  lightInt: "icon-monitor-light",
  soilPh: "icon-monitor-ph",
  soilFertility: "icon-monitor-fertility",
  soilTemp: "icon-monitor-temp",
  soilHumidity: "icon-monitor-wet"
};
// 1：过低   2：偏低   3：适宜  4：偏高  5：过高
export const status = ["异常", "偏低", "偏低", "适宜", "偏高", "偏高"];
// 设备对应的有效字段
export const filterArr = [
  "airHumidity",
  "airTemperature",
  "airPressure",
  "lux",
  "humidity",
  "ec",
  "temperature"
];
export const duognArr = [
  "airHumidity",
  "airTemperature",
  "airPressure",
  "lux",
  "windSpeed",
  "windDirection",
  "rainfall",
  "humidity",
  "ec",
  "temperature"
];

export const gpyField = [
  "sugar",
  "moisture",
  "acidity",
  "fiber",
  "fat",
  "protein"
];
export const soilField = [
  "airTemp",
  "airHumidity",
  "lightInt",
  "soilPh",
  "soilFertility",
  "soilTemp",
  "soilHumidity"
];
export const chlorophyllField = ["spad", "nitrogenContent"];
// id选键值
export const filterType = {
  4962: "micro",
  4956: "micro",
  6288: "micro",
  4990: "qxsqy",
  5250: "trjcy",
  6749: "trjcy",
  4958: "gpjcy",
  4963: "gpjcy",
  6716: "zwyyt",
  5311: "zwyyt",
  6408: "zwyyt",
  6725: "Intelligence"
};
// 设备信息
export const DeviceInfoObj = {
  gpjcy: {
    name: "光谱检测仪",
    icon: "spe",
    img: gpjcy
  },
  trjcy: {
    name: "土壤检测仪",
    icon: "tr",
    img: trjcy
  },
  micro: {
    name: "微型气象检测仪",
    icon: "as",
    img: wxqxy
  },
  zwyyt: {
    name: "植物营养检测仪",
    icon: "yy",
    img: zwyyjcy
  },
  Intelligence: {
    name: "智能设备数据采集器",
    icon: "yy",
    img: zwyyjcy
  }
};
// 数据单位
export const keyUnit = {
  airHumidity: "%RH",
  airTemperature: "℃",
  airPressure: "kPa",
  lux: "Lux",
  humidity: "%",
  ec: "us/cm",
  temperature: "℃",
  sugar: "%",
  moisture: "%",
  acidity: "",
  fiber: "%",
  fat: "%",
  protein: "%",
  spad: "spad",
  nitrogenContent: "%",
  airTemp: "℃",
  lightInt: "Lux",
  soilPh: "",
  soilFertility: "us/cm",
  soilTemp: "℃",
  soilTemperature: "℃",
  soilHumidity: "%",
  windSpeed: "m/s",
  rainfall: "mm/min",
  toc: "mg/L",
  so2: "ppm",
  noise: "mm"
};
// 上传图片host
export const imgHost = "/v4/web/telecom/upload/image";
// 上传文件host
export const fileHost = "/v4/web/tencentcloud/upload";
// 动态模型对应的单位
export const unit = {
  "tq-pa": "kPa",
  "tq-light": "Lux",
  "tq-wet": "%",
  "tq-temp": "℃",
  "tr-ec": "us/cm",
  "tr-wet": "%",
  "tr-temp": "℃",
  "yy-yls": "spad",
  "yy-n": "%",
  "fruit-water": "%",
  "fruit-sugar": "%",
  "fruit-qwx": "%",
  "fruit-df": "%",
  "fruit-dbz": "%"
};

// 多功能气象仪协议描述
export const duognengField = [
  "airTemperature",
  "airHum",
  "lux",
  "airPressure",
  "windSpeed",
  "windDirection",
  "rainfall",
  "hum",
  "ec",
  "temperature"
];
// RTU+墒情仪协议描述
export const rtuField = ["humidity", "ec", "temperature"];
// 水质检测仪协议描述

export const waterField = [
  "toc",
  "cod",
  "lux",
  "chromaticity",
  "turbidity",
  "uv254"
];
// 七大区对应的省份
export const partArray = [
  ["黑龙江省", "吉林省", "辽宁省"],
  ["北京市", "天津市", "河北省", "山西省", "内蒙古自治区"],
  [
    "上海市",
    "江苏省",
    "浙江省",
    "安徽省",
    "福建省",
    "江西省",
    "山东省",
    "台湾"
  ],
  ["河南省", "湖北省", "湖南省"],
  ["广东省", "广西壮族自治区", "海南省", "香港特别行政区", "澳门特别行政区"],
  ["重庆市", "四川省", "贵州省", "云南省", "西藏自治区"],
  ["陕西省", "甘肃省", "青海省", "宁夏回族自治区", "新疆维吾尔自治区"]
];
